export function reportError(e) {
    console.error(e);
    // const error = typeof e === 'string' ? new Error(e) : e;
}
export function runAndIgnoreError(fn) {
    try {
        fn && fn();
    }
    catch (e) {
        console.warn('An error was ignored:', e);
    }
}
